import {
  getGraphicalAd,
  sendGraphicalAdEvent,
  getIDMTargetingParameters,
} from "./service";
import {
  IDMTargeting,
  Targeting,
  AdType,
  AdResponse,
} from "@digital-media/ad-model";

declare global {
  interface Window {
    getGraphicalAd: (
      targeting: Targeting,
      numberOfAds: number,
      type: AdType,
    ) => Promise<AdResponse>;
    sendGraphicalAdEvent: (eventUrl: string, type: AdType) => void;
    getIDMTargetingParameters: (
      transactionId: string,
      smartpointEnv: string,
      pcc: string,
      gds: string
    ) => Promise<IDMTargeting>;
    refetchInterval: number;
  }
}

window.getGraphicalAd = getGraphicalAd;
window.sendGraphicalAdEvent = sendGraphicalAdEvent;
window.getIDMTargetingParameters = getIDMTargetingParameters;
window.refetchInterval = 10000;
